import _get from 'lodash/get';
import { HashratesWidget } from '@/features/accountingAndAnonymous/Hashrates';
import { SharesWidget as SharedSharesWidget } from '@/features/accountingAndAnonymous/Shares';
import Stats from '@/features/accountingAndAnonymous/Stats';
import { SharesWidget } from '@/features/sha256/Shares';
import { WorkersWidget, WorkersModal } from '@/features/accountingAndAnonymous/Workers';
import { PayoutsWidget, PayoutsIncomeChartWidget, PayoutsModal } from '@/features/accountingAndAnonymous/Payouts';
import { useNavigation } from '@/processes/Router';

const Dashboard = () => {
  const { isBTC, isLTCBTC } = useNavigation();

  return (
    <>
      {isBTC || isLTCBTC ? (
        <div className='inner'>
          <Stats className="mb-4 sm:mb-8"/>
          <HashratesWidget className="mb-6"/>
          <WorkersWidget className='mb-6'/>

          <div className="flex flex-col md:flex-row -mx-3">
            <div className="px-3 w-full md:w-1/2 mb-6">
              <SharesWidget className='h-full'/>
            </div>
            <div className="px-3 w-full md:w-1/2 mb-6">
              <PayoutsWidget className='h-full'/>
            </div>
          </div>
        </div>
      ) : (
        <div className='inner'>
          <Stats className="mb-4 sm:mb-8"/>
          <HashratesWidget className="mb-6"/>

          <div className="flex flex-col md:flex-row -mx-3">
            <div className="px-3 w-full md:w-1/2 mb-6">
              <WorkersWidget className='h-full'/>
            </div>
            <div className="px-3 w-full md:w-1/2 mb-6">
              <SharedSharesWidget className='h-full'/>
            </div>
          </div>

          <div className="flex flex-col md:flex-row -mx-3">
            <div className="px-3 w-full md:w-1/2 xl:w-3/5 mb-6">
              <PayoutsIncomeChartWidget className="h-full flex flex-col justify-between"/>
            </div>
            <div className="px-3 w-full md:w-1/2 xl:w-2/5 mb-6">
              <PayoutsWidget className='h-full'/>
            </div>
          </div>
        </div>
      )}

      <WorkersModal />
      <PayoutsModal />
    </>
  );
}

export default Dashboard;
